'use strict'

import { SnackbarProps } from '@design/objects/snackbar/contract'

export interface SnackbarType {
  show: () => void
  hide: () => void
}

export type SnackbarConfig = Partial<SnackbarProps>

export default function (element: string | HTMLElement, config?: SnackbarConfig): SnackbarType | void {
  let tempEl: HTMLElement | string | null = element

  if (typeof element === 'string') {
    tempEl = document.querySelector<HTMLElement>(element)
  }

  if (!tempEl || typeof tempEl === 'string') {
    return
  }

  const el = tempEl
  let timer: number | ReturnType<typeof setTimeout> | null = null

  const buttonEl = el.querySelector<HTMLButtonElement>('.o-snackbar__close')

  const autoClose = el.hasAttribute('data-autoclose') && el.getAttribute('data-autoclose') === 'true'
  const reusable = el.hasAttribute('data-reusable') && el.getAttribute('data-reusable') === 'true'
  const visible = el.hasAttribute('data-visible') && el.getAttribute('data-visible') === 'true'

  const closeFn = (): void => {
    el.addEventListener('transitionend', () => {
      !reusable && el.remove()
      config && config.onClose && config.onClose()
    })
  }

  const autoCloseFn = (): void => {
    timer = setTimeout(() => {
      closeFn()
      el.setAttribute('data-visible', 'false')
    }, 5 * 1000)
  }

  if (buttonEl) {
    buttonEl.addEventListener('click', () => {
      timer && clearTimeout(timer)
      closeFn()
      el.setAttribute('data-visible', 'false')
    })
  }

  if (autoClose === true && visible === true) {
    autoCloseFn()
  }

  return {
    show: () => {
      el.setAttribute('data-visible', 'true')
      autoClose === true && autoCloseFn()
    },
    hide: () => el.setAttribute('data-visible', 'false'),
  }
}
